import { handleAPI, API_VERSION_ONE } from '../../../itrust_common/utils/apiUtils';

export function patientReportsLoad(filters) {
  // const url = `/${API_VERSION_ONE}/patients/${patient_id}/reports`;
  const url = `/${API_VERSION_ONE}/reports`;
  const method = 'GET'

  return {
    type: 'PATIENT_REPORTS_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function patientReportPreview(reportId, filters) {
  // const url = `/${API_VERSION_ONE}/patients/${patient_id}/reports/preview`;
  const url = `/${API_VERSION_ONE}/reports/${reportId}/preview`;
  const method = 'GET'

  return {
    type: 'PATIENT_REPORT_PREVIEW',
    payload: handleAPI(url, filters, method)
  };
}

export function patientReportEmail(reportId, filters) {
  // const url = `/${API_VERSION_ONE}/patients/${patient_id}/reports/email`;
  const url = `/${API_VERSION_ONE}/reports/${reportId}/email`;
  const method = 'GET'

  return {
    type: 'PATIENT_REPORT_EMAIL',
    payload: handleAPI(url, filters, method)
  };
}

export function patientReportEdit(id) {
  return {
    type: 'PATIENT_REPORT_EDIT',
    id,
  };
}

export function patientReportEditCancel() {
  return {
    type: 'PATIENT_REPORT_EDIT_CANCEL'
  };
}
